var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-loading',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"body"},[_c('MainInfo'),_c('VarietyImage'),_c('Variety'),_c('GrowingMethods'),(!_vm.hydro)?_c('YieldGoal'):_vm._e()],1),_c('Stages')],1)}
var staticRenderFns = []

export { render, staticRenderFns }